import React from "react";
import MobileSliderPagesCloseButton from "./MobileSliderPagesCloseButton/MobileSliderPagesCloseButton";
import {
    MobileSliderPagesHeaderCloseButtonContainerStyled,
    MobileSliderPagesHeaderContentStyled
} from "./styled/MobileSliderPagesStyled";
import { SliderMobileModalHeaderStyled } from "./styled/MobileAssetInfoHeaderStyled";

function SliderMobileModalHeader(props) {
    const { children, ...rest } = props;
    return <SliderMobileModalHeaderStyled>
        <MobileSliderPagesHeaderContentStyled>
            {children}
        </MobileSliderPagesHeaderContentStyled>
        <MobileSliderPagesHeaderCloseButtonContainerStyled>
            <MobileSliderPagesCloseButton {...rest}/>
        </MobileSliderPagesHeaderCloseButtonContainerStyled>
    </SliderMobileModalHeaderStyled>
}

export default SliderMobileModalHeader;
